import { styles } from 'consts';
import styled from 'styled-components';

const { textColorGray, fontMontserrat, modalButton, footerColor2 } = styles;

export const Footer = styled.footer`
  @media (max-width: 767px) {
    font-family: ${fontMontserrat};
    font-size: 0.75rem;
    font-weight: 300;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.25rem;
    letter-spacing: normal;
    color: ${footerColor2} !important;
    margin-bottom: 20rem;
  }

  margin-top: 1rem;
  box-sizing: border-box;
  padding: 0 0.5rem;
  width: 100%;
  font-size: 0.8rem;
  font-family: ${fontMontserrat};
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.49;
  letter-spacing: 0.017rem;
  color: ${textColorGray};

  @media (min-width: 768px) {
    padding: 0 1.5rem;
  }

  a {
    color: ${footerColor2};
  }
`;

export const FooterSupplied = styled.div`
  p {
    display: block;
    height: 2rem;
    padding-bottom: 0;
    line-height: 1.33;
    color: ${modalButton};
    text-align: left;
  }
`;

export const List = styled.ul`
  list-style-type: lower-alpha;
  margin-left: 40px;
`;

export const TextContainer = styled.div`
  margin-bottom: 8px;
  overflow-wrap: break-word;
`;

export const ExpandElement = styled.span`
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  margin-left: 10px;
  white-space: nowrap;
  color: white;

  @media (max-width: 768px) {
    color: ${textColorGray} !important;
  }
`;
